// import countryCodeList from 'src/platform/user/profile/vap-svc/constants/countries.json';
import { veteranFields } from '../definitions/constants';

const buildPhoneValue = phoneNum => {
  if (phoneNum) {
    // phone number has already been filled in, profile uses objects
    if (typeof phoneNum === 'string') {
      return {
        callingCode: '',
        contact: phoneNum,
        countryCode: '',
      };
    }
    //  USA Phone Number
    if (
      phoneNum?.isInternational === false &&
      phoneNum?.phoneNumber &&
      phoneNum?.areaCode &&
      Number.isNaN(parseInt(phoneNum?.countryCode, 10)) === false
    ) {
      return {
        callingCode: 1,
        contact: `${phoneNum.areaCode}${phoneNum.phoneNumber}`,
        countryCode: 'US',
      };
    }
    return {
      // reason: more readable as a single line
      // eslint-disable-next-line prettier/prettier
      callingCode: Number.isNaN(parseInt(phoneNum?.countryCode, 10)) ? '' : parseInt(phoneNum.countryCode, 10),
      contact: phoneNum.phoneNumber || '',
      countryCode: phoneNum?.isInternational ? 'GB' : 'US', // <- nice to have: map "39" to CountryIso2
    };
  }
  return undefined;
};

const singleChar = value => (value ? String(value).slice(0, 1) : '');

export default function prefillTransformer(pages, formData, metadata, state) {
  const profile = state?.user?.profile || {};
  const vaProfile = profile?.vaProfile || {};
  const existingVeteran = formData?.[veteranFields.parentObject] || {};

  let fullName = {};
  if (existingVeteran?.[veteranFields.fullName]) {
    fullName = {
      ...existingVeteran[veteranFields.fullName],
      middle: singleChar(existingVeteran[veteranFields.fullName].middle),
    };
  } else {
    fullName.first = profile?.userFullName?.first || '';
    fullName.middle = singleChar(profile?.userFullName?.middle);
    fullName.last = profile?.userFullName?.last || '';
  }

  const dateOfBirth =
    existingVeteran?.[veteranFields.dateOfBirth] ||
    profile.dob ||
    profile.birthDate ||
    vaProfile.birthDate ||
    '';

  const ssn = existingVeteran?.[veteranFields.ssn] || '';

  const phoneNum =
    existingVeteran?.[veteranFields.homePhone]?.contact ||
    profile?.vapContactInfo?.homePhone ||
    profile?.vapContactInfo?.mobilePhone ||
    profile?.vapContactInfo?.workPhone ||
    '';
  const homePhone = buildPhoneValue(phoneNum);

  const alternatePhoneNum =
    existingVeteran?.[veteranFields.alternatePhone]?.contact ||
    profile?.vapContactInfo?.workPhone ||
    profile?.vapContactInfo?.mobilePhone ||
    '';
  const alternatePhone = buildPhoneValue(alternatePhoneNum);

  const email =
    existingVeteran?.[veteranFields.email] ||
    profile?.email ||
    profile?.vapContactInfo?.email ||
    '';

  let address = {};
  if (existingVeteran?.[veteranFields.address]) {
    address = existingVeteran[veteranFields.address];
  } else {
    address.street =
      profile?.vapContactInfo?.mailingAddress?.addressLine1 || '';
    address.street2 =
      profile?.vapContactInfo?.mailingAddress?.addressLine2 || '';
    address.city = profile?.vapContactInfo?.mailingAddress?.city || '';
    address.state = profile?.vapContactInfo?.mailingAddress?.stateCode || '';
    address.country =
      profile?.vapContactInfo?.mailingAddress?.countryCodeIso3 || '';
    address.postalCode = profile?.vapContactInfo?.mailingAddress?.zipCode || '';
  }

  return {
    pages,
    formData: {
      ...formData,
      [veteranFields.parentObject]: {
        ...existingVeteran,
        [veteranFields.fullName]: fullName,
        [veteranFields.dateOfBirth]: dateOfBirth,
        [veteranFields.ssn]: ssn,
        [veteranFields.address]: address,
        [veteranFields.homePhone]: homePhone,
        [veteranFields.alternatePhone]: alternatePhone,
        [veteranFields.email]: email,
      },
    },
    metadata,
  };
}
